<template>
    <common-modal v-if="isOpen" width="small" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="medium">
            <common-content-spacer height="medium">
                <common-warning size="small" :text="$t('modals.upload_report_leave_modal.warning')"></common-warning>

                <p class="upload-report-leave-modal__text">
                    {{ $t('modals.upload_report_leave_modal.text') }}
                </p>

                <div>
                    <common-buttons>
                        <common-button
                            :label="$t('modals.upload_report_leave_modal.buttons.dont_send')"
                            type="secondary"
                            @click="emitEvent({ name: 'close' })"
                        ></common-button>
                        <common-button
                            :label="$t('modals.upload_report_leave_modal.buttons.send_files')"
                            type="primary"
                            @click="emitEvent({ name: 'send-report' })"
                        ></common-button>
                    </common-buttons>
                </div>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    export default {
        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>

<style scoped>
    .upload-report-leave-modal__text {
        text-align: center;
        color: #333333;
        font-weight: 600;
        padding-top: 30px;
    }
</style>
